
export const opcoesBrf = [
    {
        opcao: "BRF A",
        valor: 1,
    },
    {
        opcao: "BRF B",
        valor: 2,
    },
    {
        opcao: "BRF C",
        valor: 3,
    },
    {
        opcao: "BRF Spot",
        valor: 4,
    },
    {
        opcao: "BRF OTM",
        valor: 5,
    },
    {
        opcao: "BRF Inelegível",
        valor: 6,
    },
];

export const opcoes = [
    {
        opcao: "Cavalo",
        valor: 1,
    },
    {
        opcao: "Carreta",
        valor: 2,
    },
    {
        opcao: "Bitrem",
        valor: 3,
    },
    {
        opcao: "Tritrem",
        valor: 4,
    },
    {
        opcao: "Automovel",
        valor: 5,
    },
];

export const itensFiltro = [
    {
        nomeColuna: "Placa Cavalo",
        field: "placaCavalo",
        filtro: "true",
    },
    {
        nomeColuna: "Placa Carreta",
        field: "placaCarreta",
        filtro: "true",
    },
    {
        nomeColuna: "Placa Segunda Carreta",
        field: "placaCarreta2",
        filtro: "true",
    },
    {
        nomeColuna: "Proprietario",
        field: "proprietario",
    },
    {
        nomeColuna: "Motorista",
        field: "veiculoMotorista",
    },
    {
        nomeColuna: "Motorista2",
        field: "motorista2",
    },
    {
        nomeColuna: "Elegível BRF",
        field: "elegivelBrf",
    },
];

export const camposObrigatorios = [
    "placaCavalo",
    "proprietario",
    "motorista",
    "tipoCarroceria",
    "tipoVeiculoConjuntos",
    "tipoVeiculo",
    "elegivelBrf",
];

export const labelVeiculo = (data: ElegivelOption) => <div>{data.opcao}</div>;

type ElegivelOption = {
    valor: number;
    opcao: string;
};

export const opcoesVeiculo: ElegivelOption[] = opcoes.map((data) => ({
    value: data.valor,
    label: data.opcao,
    ...data,
}));

export const opcoesSelect = opcoesBrf.map((data) => ({
    value: data.valor,
    label: data.opcao,
    ...data,
}));

export const estiloBase = (props?: { classeCss?: string }) => ({
    control: (provided: any) => ({
        ...provided,
        minHeight: "30px",
        borderRadius: "7px",
        border: "1px solid var(--Background-Input, #F2F2F2)",
        background: "var(--Background-Input, #F2F2F2)",
        "&:hover": { background: "#F0F6FF" },
    }),
    placeholder: (provided: any) => ({
        ...provided,
        color: "var(--Placeholder-Color, #888)",
        fontSize: "12px",
    }),
    menu: (provided: any) => ({
        ...provided,
        width: "max-content",
        minWidth: props?.classeCss ? props.classeCss : "250px",
    }),
    singleValue: (p: any) => ({ ...p, fontSize: "13px" }),
    option: (p: any) => ({ ...p, fontSize: "13px" }),
});

export const estiloErro = (props?: { classeCss?: string }) => ({
    ...estiloBase(props),
    control: (provided: any) => ({
        ...provided,
        minHeight: "30px",
        borderRadius: "7px",
        border: "1px solid red",
        background: "var(--Background-Input, #F2F2F2)",
        "&:hover": { background: "#F0F6FF" },
    }),
});

export const estiloCidadeEstado = (props: { classeCss?: string }) => ({
    control: (provided: any) => ({
        ...provided,
        minHeight: "30px",
        borderRadius: "7px",
        border: "1px solid var(--Background-Input, #F2F2F2)",
        background: "var(--Background-Input, #F2F2F2)",
        "&:hover": {
            background: "#F0F6FF",
        },
    }),
    placeholder: (provided: any) => ({
        ...provided,
        color: "var(--Placeholder-Color, #888)",
        fontSize: "12px",
    }),
    menu: (provided: any) => ({
        ...provided,
        width: "max-content",
        minWidth: props.classeCss ? props.classeCss : "250px",
    }),
    singleValue: (provided: any) => ({
        ...provided,
        fontSize: "13px",
    }),
    option: (provided: any) => ({
        ...provided,
        fontSize: "13px",
    }),
});


export const valoresIniciais = {
    motorista3: "N/D",
    motorista4: "N/D",
    motorista5: "N/D",
    motorista6: "N/D",
    motorista7: "N/D",
    motorista8: "N/D",
    motorista9: "N/D",
    motorista10: "N/D",
    motorista11: "N/D",
    motorista12: "N/D",
};

export const validadoresIniciais = {
    placaCavalo: "false",
    proprietario: "false",
    motorista: "false",
    tipoCarroceria: "false",
    tipoVeiculoConjuntos: "false",
    elegivelBrf: "false",
    tipoVeiculo: "false",
};